import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const LayoutDiv = styled('div', {
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: 1320,

  [`@media screen and (max-width: ${1320 + 60}px)`]: {
    paddingLeft: 40,
    paddingRight: 40,
  },
});

export const PageLayout = ({ className, styles, ...props }) => {
  return <LayoutDiv {...props} />;
};

PageLayout.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.shape({}),
};

PageLayout.defaultProps = {
  className: null,
  styles: null,
};
